// extracted by mini-css-extract-plugin
module.exports = {"layoutDarkContent":"style_layoutDarkContent__1IMqO","layoutDefaultBox":"style_layoutDefaultBox__NY0Ow"};